<template>
  <p class="text-center text-red-500" v-if="error">{{ error }}</p>
  <div class="flex justify-center">
    <div class="w-1/3">
      <div class="mt-2 mb-10">
        <label for="">Seleccione entrega o retiro</label>
        <select class="form-select" v-model="entrega" name="" id="">
          <option :value="true">Entrega</option>
          <option :value="false">Retiro</option>
        </select>
      </div>
      <div v-if="entrega" class="mt-2">
        <div v-if="direcciones.length > 0">
          <label for="">Dirección</label>
          <select class="form-select" v-model="iddir" @change="errorDir" name="" id="">
            <option v-for="(dir, key) in direcciones" :key="key" :value="dir.ID_DIR">{{ dir.DIRECCION_DIR + (dir.LOCALIDAD_DIR ? ' - ' + dir.LOCALIDAD_DIR : '') + ' - Exp: ' + (dir.NOMBRE_EXP || 'PROPIO') }}</option>
          </select>
          <p>Expreso: {{ direcciones.find(x => x.ID_DIR == iddir).NOMBRE_EXP || 'PROPIO' }}</p>
        </div>
        <div v-else>
          <label for="">Dirección:</label>
          <p>
            {{ this.usuario.direccion }}
          </p>
        </div>
      </div>
      <div class="mt-2">
        <textarea v-model="obs" class="form-control" cols="30" placeholder="Observacion.." rows="5"></textarea>
      </div>
      <div v-if="esVendedor" class="mt-2 flex justify-center" @change="linea == 'c' ? idlp = 4 : idlp = 1">
        <label for="jirafa">
          <img class="h-14" src="../assets/jirafa.jpg" alt="">
        </label>
        <input type="radio" value="j" v-model="linea" name="linea" id="jirafa">
        <label for="caballo">
          <img class="h-14" src="../assets/caballo.jpg" alt="">
        </label>
        <input type="radio" value="c" v-model="linea" name="linea" id="caballo">
      </div>
      <div v-if="esVendedor" class="mt-2">
        <select class="form-select" v-model="idlp" name="" id="">
          <option v-if="linea == 'j'" value="1">1</option>
          <option v-if="linea == 'j'" value="2">2</option>
          <option v-if="linea == 'c'" value="4">4</option>
        </select>
      </div>
      <div v-if="cargando" class="w-full flex justify-center">
        <img class="w-20" src="https://thebowlcut.com/cdn/shop/t/41/assets/loading.gif?v=157493769327766696621701744369" alt="">
      </div>
      <div>
        <button class="btn btn-success btn-sm mt-2" @click="crearPedido" :disabled="cargando">Enviar</button>
      </div>
    </div>
  </div>
</template>

<script>
import pedidosService from '@/services/pedidos.service';
import usuarioService from '@/services/usuario.service';
  export default {
    data() {
      return {
        entrega: true,
        userId: '',
        idcli: null,
        direcciones: [],
        iddir: 0,
        idexp: '',
        linea: 'j',
        obs: '',
        idlp: 1,
        error: '',
        cargando: false,
        usuario: {}
      };
    },
    mounted() {
      if (this.$route.params.idcli) {
        this.idcli = this.$route.params.idcli
      }
      this.inicio()
    },
    methods: {
      errorDir() {
        if ( this.error == 'Seleccione una direccion valida') {
          this.error = ''
        }
      },
      crearPedido() {
        this.cargando = true
        var iddir = 0 
        if (this.entrega) {
          if (this.direcciones.length > 0 && !this.iddir) {
            this.error = 'Seleccione una direccion valida'
            return
          } else {
            iddir = this.iddir || -1
          }
        }
        if (!this.esVendedor) {
          this.idlp = -1
        }
        if (!this.obs ) {
          this.obs = ''
        }
        pedidosService.crearPedido(this.idcli, iddir, encodeURIComponent(this.obs), this.idlp)
          .then(() => {
            // pedidosService.deleteCarritoUsuCli(this.userId, this.idcli)
            //   .then(() => {})
            //   .catch((errr) => {
            //     console.log(errr)
            //   })
            //   .finally(() => {
                this.$root.alertSuccess = true
                this.$root.isAlertVisible = true
                this.$router.push('/pedido-confirmado')
              // })
         
          })
          .catch((err) => {
            console.log(err)
            this.$root.alertSuccess = false
            this.$root.isAlertVisible = true
          })
          .finally(() => {
            this.cargando = false
          })
      },
      inicio() {
        var user = JSON.parse(localStorage.getItem('user'))
        this.userId = user.id
        console.log('1')
        
        if (!this.esVendedor && !this.idcli) {
          console.log('2')
          usuarioService.getUserId(this.userId)
            .then((res) => {
              console.log('3')
              this.usuario = res.data
              user.idcli = res.data.idcli
              this.idcli = res.data.idcli
              this.inicio()
            })
            .catch((err) => console.log(err))
        }
        if (!this.esVendedor || this.idcli)
        console.log('4')
          pedidosService.getCountItemsCarritoCliente(user.id, this.idcli)
            .then(res => {
              console.log('5')
              if (res.data) {
                this.cargarDatos()
              }
              this.direccionesUsu(this.idcli ? this.idcli : user.idcli)
            })
            .catch(err => {
              console.log(err)
            })
      },
      direccionesUsu(idusu) {
        console.log('6')
        if (idusu) {
          usuarioService.idcvd(idusu)
            .then((res) => {
              this.idlp = res.data.IDCDV_CLI
              this.linea = [1, 2].includes(this.idlp) ? "j" : "c"
            })
          console.log('7')
          usuarioService.direccionesUsuBodell(idusu)
            .then(res => {
              console.log('8')
              if (res.data.length > 0) {
                console.log('9')
                this.direcciones = res.data 
                this.iddir = res.data[0].ID_DIR
              }
              // this.procesar()
            })
            .catch(err => {
              console.log(err)
            })
        }
      },
      // procesar() {
      //   this.idexp = this.expresos.find(x => x.ID_EXP == this.direcciones[0].ID_EXP).ID_EXP
      // },
      cargarDatos() {
        // direcciones
        // expresos
      }
    },
    computed: {
      esVendedor() {
        return this.$root.user.tipo != "cliente";
      },
    },
  };
</script>

